<script setup lang="ts">
import type { Locales, StepDto } from '@/services/types/api.types';
import FormStepMatrixRowList from '@/components/FormSteps/FormStepMatrixRowList.vue';
import FormStepMatrixChoiceList from '@/components/FormSteps/FormStepMatrixChoiceList.vue';

const props = defineProps<{
  step: StepDto;
  formId: number;
  stepIndex: number;
  permissions: {
    canChoicesBeDeleted?: boolean;
  };
  languageEnabled: Locales[];
}>();
</script>

<template>
  <form-step-matrix-choice-list
    :rows="[...(step.level_choices ?? [])].sort((a, b) => a.value - b.value)"
    :form-id="formId"
    :step-id="step.id!"
    :can-choices-be-deleted="permissions.canChoicesBeDeleted"
    :languageEnabled="languageEnabled"
  />
  <q-separator class="q-ma-lg" />
  <form-step-matrix-row-list
    :rows="[...(step.levels ?? [])].sort((a, b) => a.order_num - b.order_num)"
    :form-id="formId"
    :step-id="step.id!"
    :can-choices-be-deleted="permissions.canChoicesBeDeleted"
    :languageEnabled="languageEnabled"
  />
</template>
